import React from 'react'

const Paginate = (props) => {
    const {paginate, pagination} = props;
    return (
        <div className="pagination">
        <button
            onClick={() => paginate(pagination.currentPage - 1)}
            disabled={pagination.currentPage === 1}
        >
            &lt;
        </button>
        {Array.from({
            length:
            pagination.paginationRange.end - pagination.paginationRange.start + 1,
        }).map((_, index) => (
            <button
            key={index}
            onClick={() => paginate(pagination.paginationRange.start + index)}
            className={
                pagination.currentPage === pagination.paginationRange.start + index
                ? "active"
                : ""
            }
            >
            {pagination.paginationRange.start + index}
            </button>
        ))}
        <button
            onClick={() => paginate(pagination.currentPage + 1)}
            disabled={pagination.currentPage === pagination.totalPages}
        >
            &gt;
        </button>
        </div>
  );
}

export default Paginate;